<template>
    <el-skeleton :loading="loading" :rows="16" animated>
        <el-page class="strategic-page" :bannerImageUrl="bannerImageUrl">
            <div class="institutional-cooperation">
                <pane-title class="pane" title="机构合作" subTitle="INSTITUTIONAL COOPERATION" />
                <div class="industry-list">
                    <div v-for="(item, index) in industryList" :key="index" class="industry-item" @click="jumpDetail(item)">
                        <div class="image-wrapper">
                            <img :src="item.pcImgUrl" :alt="item.title"/>
                        </div>
                        <div class="content-wrapper">
                            <h3 class="title">{{ item.title }}</h3>
                            <div class="description" v-if="item.description">
                                <p v-for="(line, idx) in item.description.split('|')" :key="idx">{{ line.trim() }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-page>
    </el-skeleton>
</template>

<script>
import PaneTitle from '../../components/PaneTitle/PaneTitle.vue';
export default {
    name: "strategic",
    components: { PaneTitle },
    data() {
        return {
            loading: true,
            bannerImageUrl: null,
            industryList: [],
            schoolList: []
        }
    },
    computed: {
        lang() {
            return this.$i18n.locale;
        },
    },
    methods: {
        jumpDetail(item) {
            const link = item.jumpUrl;
            if (link) {
                window.open(link)
            }
        },
        configData(record) {
            this.industryList = (record['61'] && record['61'] || []).sort((a, b) => a.sort - b.sort)
        },
        getData(language) {
            this.$http.getOnlyContent({
                itemType: '6',
                platform: 'pc',
                language
            }).then(res => {
                this.loading = false;
                this.bannerImageUrl = res.imageMaps['60'] && res.imageMaps['60'][0] && res.imageMaps['60'][0].imgUrl
                this.configData(res.crmOweContentMaps)
            });
        },
        getDataByLang(lang) {
            if (lang === 'zh') {
                this.getData('china');
            } else {
                this.getData('english');
            }
        }
    },
    watch: {
        "$i18n.locale": {
            immediate: true,
            handler(v) {
                this.getDataByLang(v);
            }
        },
    }
}
</script>

<style scoped lang="less">
.strategic-page {
    padding-bottom: 8rem;

    .pane {
        padding: 3rem 0;
    }

    .industry-list {
        padding: 0 15rem;
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 3.88rem;

        .industry-item {
            cursor: pointer;
            display: flex;
            padding: 2rem 1.5rem;
            background: #FFF;
            box-shadow: 0px 4px 30px -2px rgba(13, 20, 138, 0.10);
            transition: transform 0.3s ease;

            &:hover {
                transform: scale(1.02);
            }

            .image-wrapper {
                background-color: #F8F8FC;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 1;
                aspect-ratio: 437 / 388;
                img {
                    width: 80%;
                    height: auto;
                    display: block;
                }
            }

            .content-wrapper {
                flex: 2;
                padding-left: 1.5rem;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;

                .title {
                    color: var(--333333, #333);
                    font-family: "Source Han Sans CN";
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 700;
                    line-height: 2rem; /* 200% */
                    margin: 0;
                }

                .description {
                    color: var(--333333, #333);
                    text-align: justify;
                    font-family: "Source Han Sans CN";
                    font-size: 1rem;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 2rem; /* 200% */
                    letter-spacing: -0.01rem;

                    p {
                        margin: 1rem 0;
                    }
                }
            }
        }
    }
}

/* 小屏幕（移动端） */
@media screen and (max-width: 767px) {
    .strategic-page {
        padding-bottom: 2.25rem;
        .industry-list {
            padding: 0 1rem;
        }

        .industry-list {
            padding: 0;
            display: block;
            .industry-item{
                margin: 2rem 0;
                flex-direction: column;


                .image-wrapper {

                 aspect-ratio: 657/334;
                background-color: white;

                img{
                    max-width: 100%;
                    max-height: 60%;
                    object-fit: contain;
                }
            }

            .content-wrapper {
                         padding-left: 0;
                    padding-top: 1rem;
                .title {
                    font-size: 1.16667rem;
                }

                .description {
                    font-size: 1.16667rem;
                }
            }
            }
        }
    }
}
</style>